/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgColorSpectrum = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M21 2v3h1v2h-1v15h-2V7h-1V5h1V2zm-6 16v1h2v2h-2v1h-2v-1H2v-2h11v-1zm1-16v14H2V2zm-2 2H4v10h10z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgColorSpectrum as ColorSpectrum };
